<template>
    <div class="transaction">
  
      <Header :mainHeader="true"/>
  
      <section id="transaction-products" style="padding: 10px 0px !important">
        <div class="containers">
          <h5 class="fw-bold">Purchase Management</h5>

          <div class="table-container">
            <table class="table table-hover" id="purchaseTable">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Supplier Date</th>
                        <th>Supplier PIN</th>
                        <th>Supplier Name</th>
                        <th>Items</th>
                        <th>Amount</th>
                        <th>Action</th>
                    </tr>
                </thead>
              
                <tbody v-if="purchases?.length > 0">
                    <tr v-for="(purchase,index) in purchases" v-bind:key="purchase.id">
                        <td>{{ index+1 }}</td>
                        <td>{{ purchase.salesDt }}</td>
                        <td>{{ purchase.spplrTin }}</td>
                        <td>{{ purchase.spplrNm }}</td>
                        <td>{{ purchase.totItemCnt }}</td>
                        <td>KES {{ formatToMoney(purchase.totAmt) }}</td>
                        <td>
                            <button v-if="isStringInArray(purchase.spplrInvcNo)" class="btn btn-warning btn-sm">Already Updated</button>  
                            <button v-else class="btn btn-primary btn-sm" style="margin-right: 10px;" @click="openModal(purchase)">Update</button>
                        </td>
                    </tr>
                     Add more rows as needed 
                </tbody>
                <p v-if="!loading && !purchases?.length > 0 "  style="color: red; padding: 20px; font-size: 21px;">No Purchases found</p>
            </table>
            <LoaderItem v-if="loading" />
          </div>
          
        </div>
        <div v-show="isVisible" class="modal">
            <div class="modal-content">
                <span class="close" style="position:absolute; width: fit-content; right: 0; margin-right: 20px;" @click="closeModal">&times;</span>
                <div class="row p-30">
                    <div class="col-md-5">
                        <label for="">Select Purchase Progress Status</label>
                        <select v-model="status" class="form-control" style="width: 98%;" v-if="codes[13]">
                            <option v-for="(objItem) in codes[13].dtlList" v-bind:key="objItem.id" :value="objItem.cd">{{ objItem.cdNm }}</option>
                        </select>
                    </div>
                    <div class="col-md-7">
                        <label for="">Remarks</label>
                        <input type="text" v-model="remarks" class="form-control" />
                    </div>
                
                </div>
                <div class="p-30">
                    <table class="table table-hover">
                        <thead style="width: 100% !important"><th>Purchase Item</th><th>Store Item</th></thead>
                        <tbody>
                            <tr v-for="(purchaseItem) in currentPurchase.itemList" v-bind:key="purchaseItem.itemSeq">
                                <td>
                                    <p>Item Code: <span class="detail">{{ purchaseItem.itemCd }}</span></p>
                                    <p>Item Classification Code: <span class="detail">{{ purchaseItem.itemClsCd }}</span></p>
                                    <p>Item Name: <span class="detail">{{ purchaseItem.itemNm }}</span></p>
                                    <p>Price: <span class="detail">{{ purchaseItem.prc }}</span></p>
                                    <p>Qty: <span class="detail">{{ purchaseItem.qty }}</span></p>
                                    <p>Tax: <span class="detail">{{ purchaseItem.taxAmt }}</span></p>
                                    <p>Total: <span class="detail">{{ purchaseItem.totAmt }}</span></p>
                                </td>
                                <td>
                                    <label for="">Select Item</label>
                                    <select v-model="item" style="width: 98%;" v-if="items" class="form-control">
                                        <option v-for="(objItem) in items" v-bind:key="objItem.id" :value="objItem">{{ objItem.itemNm }}</option>
                                    </select>
                                </td>
                                <td>
                                    <button class="btn btn-primary" style="margin-top: 34px;" @click="confirmPurchase(purchaseItem)">Confirm</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row">
                    <button class="btn btn-style col-md-5" style="float:right; margin: 20px;" @click="updatePurchase('NORMAL')">Update and Affect Stock Purchase</button>
                    <button class="btn btn-style col-md-5" style="float:right; margin: 20px;" @click="updatePurchaseService">Update Purchase Status Only</button>
                </div>
            </div>
        </div>
      </section>
    </div>
  </template>
  
<script>

import Header from '../../components/Header';
import Swal from 'sweetalert2'
import { toRaw } from 'vue'
import 'datatables.net-vue3';
import 'datatables.net-bs5';
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5";
import $ from 'jquery';
//import 'jszip';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.print.js';
import { formatDate } from '@/utils/commons';
import LoaderItem from "../../components/LoaderItem.vue"

export default {
name: 'PurchasePage',
components: {
    Header,
    LoaderItem
},
data(){
    return{
        token: JSON.parse(localStorage.getItem('access_token')),
        purchases: [],
        processedData: [],
        codes:[],
        items:[],
        isVisible:false,
        status: "",
        remarks: "",
        item:{},
        currentPurchase:{},
        itemList:[],
        updatedPurchases:[],
        loading: false

    }
},
methods:{
    openModal(obj){
        this.isVisible = true;
        this.currentPurchase = toRaw(obj);
    },
    closeModal() {
        this.isVisible = false;
    },
    formatToMoney(value) {
        const formattedValue = Number(value).toFixed(2);
        return formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    formatDt(value){
        formatDate(value)
    },
    confirmPurchase(obj){
        const pObj = toRaw(obj);
        const itemSeq = this.itemList.length + 1
        var newItem = {
            "itemSeq": itemSeq,
            "itemId":this.item.id,
            "itemCd": this.item.itemCd,
            "itemClsCd": this.item.itemClsCd,
            "itemNm": this.item.itemNm,
            "itemNmDef": this.item.itemCdDf,
            "bcd": pObj.bcd,
            "spplrItemClsCd": pObj.itemClsCd,
            "spplrItemCd": pObj.itemCd,
            "spplrItemNm": pObj.itemNm,
            "pkgUnitCd": pObj.pkgUnitCd,
            "pkg": pObj.pkg,
            "qtyUnitCd": pObj.qtyUnitCd,
            "qty": pObj.qty,
            "prc": pObj.prc,
            "splyAmt": pObj.splyAmt,
            "dcRt": pObj.dcRt,
            "dcAmt": pObj.dcAmt,
            "taxblAmt": pObj.taxblAmt,
            "taxTyCd": pObj.taxTyCd,
            "taxAmt": pObj.taxAmt,
            "totAmt": pObj.totAmt,
            "itemExprDt": null
        }
        this.itemList.push(newItem);
        this.item = {}
    },
    async updatePurchaseService(){
        this.itemList = [];
        this.currentPurchase.itemList.forEach(item => { 
            var newItem = {
                "itemSeq": item.itemSeq,
                "itemId":1,
                "itemCd": item.itemCd,
                "itemClsCd": item.itemClsCd,
                "itemNm": item.itemNm,
                "itemNmDef": item.itemNm,
                "bcd": item.bcd,
                "spplrItemClsCd": item.itemClsCd,
                "spplrItemCd": item.itemCd,
                "spplrItemNm": item.itemNm,
                "pkgUnitCd": item.pkgUnitCd,
                "pkg": item.pkg,
                "qtyUnitCd": item.qtyUnitCd,
                "qty": item.qty,
                "prc": item.prc,
                "splyAmt": item.splyAmt,
                "dcRt": item.dcRt,
                "dcAmt": item.dcAmt,
                "taxblAmt": item.taxblAmt,
                "taxTyCd": item.taxTyCd,
                "taxAmt": item.taxAmt,
                "totAmt": item.totAmt,
                "itemExprDt": null
            }
            this.itemList.push(newItem);            
        });
        await this.updatePurchase("PURCHASE");
    },
    async updatePurchase (type) {
        const dateTimeNow = this.getCurrentDateTimeFormatted()
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            body: JSON.stringify({ 
                "invcNo": 1,
                "orgInvcNo": 0,
                "spplrTin": this.currentPurchase.spplrTin,
                "spplrBhfId": this.currentPurchase.spplrBhfId,
                "spplrNm": this.currentPurchase.spplrNm,
                "spplrInvcNo": this.currentPurchase.spplrInvcNo,
                "regTyCd": "M",
                "pchsTyCd": "N",
                "rcptTyCd": "P",
                "type": type,
                "pmtTyCd": this.currentPurchase.pmtTyCd,
                "pchsSttsCd": this.status,
                "cfmDt": dateTimeNow,
                "pchsDt": this.currentPurchase.salesDt,
                "wrhsDt": "",
                "cnclReqDt": "",
                "cnclDt": "",
                "rfdDt": "",
                "totItemCnt": this.itemList.length,
                "taxblAmtA": this.currentPurchase.taxblAmtA,
                "taxblAmtB": this.currentPurchase.taxblAmtB,
                "taxblAmtC": this.currentPurchase.taxblAmtC,
                "taxblAmtD": this.currentPurchase.taxblAmtD,
                "taxblAmtE": this.currentPurchase.taxblAmtE,
                "taxRtA": this.currentPurchase.taxRtA,
                "taxRtB": this.currentPurchase.taxRtB,
                "taxRtC": this.currentPurchase.taxRtC,
                "taxRtD": this.currentPurchase.taxRtD,
                "taxRtE": this.currentPurchase.taxRtE,
                "taxAmtA": this.currentPurchase.taxAmtA,
                "taxAmtB": this.currentPurchase.taxAmtB,
                "taxAmtC": this.currentPurchase.taxAmtC,
                "taxAmtD": this.currentPurchase.taxAmtD,
                "taxAmtE": this.currentPurchase.taxAmtE,
                "totTaxblAmt": this.currentPurchase.totTaxblAmt,
                "totTaxAmt": this.currentPurchase.totTaxAmt,
                "totAmt": this.currentPurchase.totAmt,
                "remark": this.remarks,
                "regrNm": "Admin",
                "regrId": "Admin",
                "modrNm": "Admin",
                "modrId": "Admin",
                "itemList": this.itemList
            })
        };
        const res = await fetch(process.env.VUE_APP_URL+'/purchases', requestOptions)
        const data = await res.json()
        if(data.status == true){
            Swal.fire({
                icon: 'success',
                title: 'purchases updated successfully',
                text: data.message
            })
        }else{
            Swal.fire({
                icon: 'error',
                title: 'purchases not found',
                text: data.message
            })
        }
    },
    async getPurchases () {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        try {
            this.loading = true
            const res = await fetch(process.env.VUE_APP_URL + '/purchases', requestOptions);
            const data = await res.json();

            if (data.status === true) {
                this.purchases = data.purchases;
                console.log(this.purchases)
                this.processedData = this.preprocessData(this.purchases);
                this.initializeDataTable();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Purchase not found',
                    text: data.message
                });
            }
        } catch (error) {
           // console.error('Error fetching or parsing data:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch purchases. Please try again later.'
            });
        } finally {
            this.loading = false
        }
    },
    preprocessData(rawData) {
        return rawData?.map(item => {
            return {
                indexNo: "1",
                supplierDt: item.salesDt,
                supplierPin: item.spplrTin,
                supplierName: item.spplrNm,
                items: item.totItemCnt,
                amount: this.formatToMoney(item.totAmt),
                action: '',
            };
        });
    },
    initializeDataTable() {
        try {
            this.dataTable = $(this.$el).find('#purchasesTable').DataTable({
                responsive: true,
                language: {
                    paginate: {
                    previous: '<i class="fa fa-chevron-left"></i>', // Custom icon for previous button
                    next: '<i class="fa fa-chevron-right"></i>', // Custom icon for next button
                    },
                }, 
                dom: '<"datatable-buttons"B><"datatable-search"f>tip',
                buttons: [
                    {
                    extend: 'colvis',
                    text: 'Column Visibility',
                    className: 'btn-grey',
                    },
                    {
                    extend: 'pageLength',
                    text: 'Page Length',
                    className: 'btn-grey',
                    },
                    {
                    extend: 'csv',
                    text: 'Export CSV',
                    className: 'btn-grey',
                    exportOptions: {
                        columns: ':visible',
                    },
                    },
                    {
                    extend: 'pdfHtml5',
                    text: 'Export PDF',
                    orientation: 'landscape',
                    className: 'btn-grey',
                    exportOptions: {
                        columns: ':visible',
                    },
                    customize: this.customizePDF
                    },
                ],
                data: this.processedData,
                columns: [
                    { data: null },
                    { data: 'supplierDt' },
                    { data: 'supplierPin' },
                    { data: 'supplierName' },
                    { data: 'items' },
                    { data: 'amount' },
                    { data: 'action', render: this.renderActionButton },
                ],
                columnDefs: [
                    {
                    targets: 0,
                    searchable: false,
                    orderable: false,
                    render: (data, type, row, meta) => {
                        return meta.row + 1;
                    },
                    },
                ],
                });
            } catch (error) {
                console.log({ error })
            }
        },

        renderActionButton(data, type, row) {
            if (type === 'display') {
                let action ='';
               // eslint-disable-next-line no-constant-condition
               if("yes" == "no")
                  action += `<button  class="btn btn-warning btn-sm">Already Updated</button>`
                else 
                    action += `<button  class="btn btn-primary btn-sm" style="margin-right: 10px;" @click="openModal(${row})">Update Purchase</button>`
                return action;
            }
            
            return data;
        },
     

        customizePDF(doc) {
            doc.pageMargins = [40, 40, 40, 40]; // Set margins for the entire page
            doc.defaultStyle.columnGap = 0
            doc.content[1].fillColor = '#f2f2f2'

            doc.header = () => {
                return {
                columns: [
                    {
                    width: '*',
                    columns: [
                        /* {
                            image: logoBase64,
                            width: 150, // Adjust the width as needed
                        },*/
                        {
                        text: 'Taxpoint',
                        alignment: 'left',
                        margin: [40, 15, 0, 40], // Adjust margins as needed
                        color: '#000', 
                        bold: true,
                        fontSize: 14,

                        }
                    ]
                    },
                    {
                    width: '*',
                    stack: [
                        {
                        text: 'Products List',
                        alignment: 'right',
                        margin: [0, 15, 50, 0],
                        fontSize: 12,
                        color: '#4448B3'
                        },
                        {  
                        alignment: 'right',
                        margin: [300, 0, 0, 0],
                        width: '*',
                        columns: [
                            {
                            width: 'auto',
                            text: 'Date:',
                            alignment: 'right',
                            margin: [0, 0, 10, 0],
                            bold: true,
                            },
                            {
                            width: 'auto',
                            text: `${formatDate(new Date(), "true")}`,
                            alignment: 'right',
                            margin: [0, 0, 50, 0],
                            fontSize: 9
                            }
                        ]
                        }
                    ]
                    }
                ],
                fillColor: '#000000'
                };
            },

            doc.footer = (currentPage, pageCount) => {
                return {
                    columns: [
                    { width: '*', text: 'www.pavicongroup.co.ke', alignment: 'left' },
                    { width: '*', text: 'contact@pavicongroup.co.ke', alignment: 'center' },
                    { width: '*', text: `Page ${currentPage} of ${pageCount}`, alignment: 'center' },
                    { width: '*', text: `Printed on ${formatDate(new Date(), "true")}`, alignment: 'right' }
                    ],
                    margin: [40, 10, 40, 10], // Margin for the whole footer
                    fillColor: 'black'
            };
            };

            doc.styles.title = {
                color: '#4448B3',
                fontSize: 13,
                margin: [80, 0, 0, 40],
            };
    },


    async getUpdatePurchases () {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/purchases/updated', requestOptions)
        const data = await res.json()
        console.log(data)
        this.updatedPurchases = data.purchases
    },
    isStringInArray(task) {
        return this.updatedPurchases.some(obj => obj.spplrInvcNo==task );
    },
    async getCodes () {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/items/pullcodes', requestOptions)
        const data = await res.json()
        this.codes = data.kraResult?.clsList;
    },
    async getItems () {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/items', requestOptions)
        const data = await res.json()
        if(data.status == true){
            this.items = data.items
        }else{
            Swal.fire({
                icon: 'error',
                title: 'Items not found',
                text: data.message
            })
        }
    },
    roundToTwo(num) {
      return parseFloat(num.toFixed(2));
    },
    getCurrentDateFormatted() {
      const now = new Date();

      const year = now.getFullYear();
      // Get month, add 1 as getMonth() returns 0-11, and pad with zero if necessary
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const day = now.getDate().toString().padStart(2, '0');

      return `${year}${month}${day}`;
    },
    getCurrentDateTimeFormatted() {
      const now = new Date();

      const year = now.getFullYear();
      // Get month, add 1 as getMonth() returns 0-11, and pad with zero if necessary
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const day = now.getDate().toString().padStart(2, '0');
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const seconds = now.getSeconds().toString().padStart(2, '0');

      return `${year}${month}${day}${hours}${minutes}${seconds}`;
    }
},
mounted(){
    this.getPurchases()
    this.getCodes()
    this.getItems()
    this.getUpdatePurchases()
}
}
</script>


<style scoped>
.modal {
  display: block; 
  position: fixed; 
  z-index: 1; 
  padding-top: 100px; 
  left: 0;
  top: 0;
  width: 100%; 
  height: 100%; 
  overflow: auto; 
  background-color: rgb(0,0,0); 
  background-color: rgba(0,0,0,0.4); 
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
</style>